<template>
    <slot :desktop="$device.isDesktop"></slot>
</template>

<script setup>
</script>